<template>
  <el-sub-menu :index="String(k)" v-if="menu.menus && menu.menus.length > 0">
    <template #title>
      <el-icon>
        <component :is="$store.state.icons.icons[menu.icon]"></component>
      </el-icon>
      <span>{{ menu.name }}</span>
    </template>
    <FengMenuItem v-for="(item, ki) in menu.menus" :menu="item" :k="k + '_' + ki" :key="ki" />
  </el-sub-menu>
  <el-menu-item @click="gopage(menu)" :index="String(k)" v-else>
    <el-icon v-if="menu.icon">
      <component :is="$store.state.icons.icons[menu.icon]"></component>
    </el-icon>
    <span v-if="isNestedMenu" style="margin-left: 10px;">{{ menu.name }}</span>
    <span v-else>{{ menu.name }}</span>
  </el-menu-item>
</template>

<script>
import { pub } from '../../../common/event.js';

export default {
  name: 'FengMenuItem',
  props: {
    menu: { type: Object },
    k: { type: [String, Number], default: 1 },
  },
  computed: {
    isNestedMenu() {
      return String(this.k).includes('_');
    },
  },
  methods: {
    gopage(menu) {
      const path = menu.path;
      if (!path) return;
      if (menu.query) this.$router.push({ path, query: menu.query });
      else this.$router.push(path);
      if (menu.eventKey) pub(menu.eventKey, path);
    },
  },
};
</script>